import axiosService from "@/modules/axios-service";
import { normalizeExportMonth } from "@/modules/export-month";

class AccountService {
  path = "/accounts";
  constructor(path = undefined) {
    if (path) {
      this.path = path;
    }
  }

  async fetchAccounts() {
    return await axiosService.get(this.path);
  }

  async fetchAccountsForService() {
    return await axiosService.get(this.path);
  }

  async fetchAccountsForConsent(route) {
    return await axiosService.get(route + this.path);
  }

  refreshAccounts() {
    return axiosService.post(this.path + '/refresh');
  }

  async exportAccounts({ accountId, fromMonth, toMonth } = {}) {
    const normalizedFromMonth = normalizeExportMonth(fromMonth);
    const normalizedToMonth = normalizeExportMonth(toMonth);

    if (!normalizedFromMonth || !normalizedToMonth) {
      throw new TypeError(
        "Account export requires fromMonth and toMonth in YYYY-MM format."
      );
    }

    return await axiosService.get(this.path + "/export", {
      params: {
        ...(accountId ? { accountId } : {}),
        fromMonth: normalizedFromMonth,
        toMonth: normalizedToMonth,
      },
      responseType: "blob",
    });
  }
}

export default new AccountService();
